<template>
  <!-- 第三方登录成功回调页 -->
  <div class="callback">登录中，请稍后...</div>
</template>

<script>
import axios from 'axios'
export default {
  name: '',
  data() {
    return {
      // 三方登录成功后会返回回调页并在url上添加code
      code: '',
      // 来源页,存储在cookie中
      from: '',
      // 登录方式: QQ 4 微信 3 微博5
      loginType: '',
      // 登录终端
      loginTerminal: '',
      isMobile: 0
    }
  },
  computed: {},
  watch: {},
  created() {
    this.code = this.$route.query.code
    this.$cookies.set('thirdCode', this.code, '1d','','zhibo.tv')
    this.$cookies.set('thirdCode', this.code, '1d')
    this.from = this.$cookies.get('login_origin')
    this.loginType = this.$cookies.get('login_type')
    this.loginTerminal = this.$cookies.get('login_terminal')
    // alert('login_type')
    // alert(this.$cookies.get('login_type'))
    if (this.loginTerminal == 'H5' && this.loginType == 3) {
      this.isMobile = 1
    }
    this.thirdLoginAll()
  },
  methods: {
    // 获取用户信息
    async getUserInfo(judgeres) {
      axios.defaults.withCredentials = true
      let res = await this.$api.getUserInfo()
      console.log(res)
      // alert('走接口了')
      if (res.data.status == 200) {
        console.log('获取用户信息')
        this.$cookies.set('token', res.data.data.userToken, '1d')
        this.$cookies.set('roomNum', res.data.data.roomNum, '1d')
        // alert(res.data.data.roomNum)
        if (this.loginTerminal == 'PC') {
          this.handlePCBack(judgeres)
        }
        if (this.loginTerminal == 'H5') {
          this.handleH5back(judgeres)
        }
      } else {
        if (this.loginTerminal == 'PC') {
          this.handlePCBack(judgeres)
        }
        if (this.loginTerminal == 'H5') {
          this.handleH5back(judgeres)
        }
      }
    },
    // 三方登录回调页判断是否是新用户
    async thirdLoginAll() {
      let params = {
        code: this.code,
        state: '3HNak',
        from: this.from,
        isRemember: 1,
        loginType: this.loginType,
        is_mobile: this.isMobile
      }
      let judgeres = await this.$api.thirdLoginAll(params)
      console.log(judgeres)
      this.getUserInfo(judgeres)
    },
    // 处理PC
    handlePCBack(res) {
      console.log('处理PC三方回调')
      // 状态码207代表新用户，需要绑定，除此之外均返回到来源页
      if (res.data.status == 207) {
        this.$cookies.set('isThirdNew', '1', '1d', null, 'zhibo.tv')
        location.replace(this.from)
      }else{
        setTimeout(() => {
          location.replace(this.from)
        }, 1000)
      }
      // 如果开小窗再处理
      // setTimeout(() => {
      //   console.log('需要绑定', self.opener.location, window.opener.location)
      //   window.close()
      //   // 处理iframe跨域
      //   self.opener.parent.postMessage({ command: 'reload' }, '*')
      // }, 2000)
    },
    // 处理H5
    handleH5back(res) {
      console.log('处理H5三方回调', res)
      if (res.data.status == 207) {
        // 需要绑定，跳转绑定页
        this.$router.replace({
          path: 'bindtel'
        })
      } else if (res.data.status == 200) {
        // 登录成功
        location.replace(this.from)
      } else {
        this.getUserInfo()
        setTimeout(() => {
          this.$router.replace({
            path: 'mobilelogin'
          })
        }, 1000)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.callback {
  width: 100vw;
  height: 100vh;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
